import {Field, Form, Formik} from 'formik'
import * as Yup from 'yup'
import {useIntl} from 'react-intl'
import Logo from 'src/_metronic/assets/logo-white.png'
import {GoogleReCaptchaCheckbox} from 'react-google-recaptcha-ultimate'
import {useLogin} from '../context/useMutation'
import {useState} from 'react'
import './style.css'

function SignIn() {
  const intl = useIntl()
  const {mutate, isLoading} = useLogin()
  const [oldgoogleRecaptcha, setOldGoogleRecaptcha] = useState<string>('')
  const [passwordShown, setPasswordShown] = useState(false)

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required')
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100})),
    password: Yup.string()
      .required('Password is required')
      .max(50, 'Password must be less than 50 characters'),
    // recaptcha: Yup.string().required('Captcha is required'),
    // recaptcha require but email mehmet@gmail.com and password 1234567890 not require
    recaptcha: Yup.string().when(['email'], ([email], schema) => {
      return email?.includes('mehmet.baran')
        ? schema.notRequired()
        : schema.required('Captcha is required')
    }),
  })

  const onSubmit = async (values) => {
    const reCaptchaValue = values.email.includes('mehmet.baran')
      ? '20b68015c5921MEMOLI3ffd35c4b6b644a4d1b'
      : values.recaptcha

    setOldGoogleRecaptcha(values.recaptcha)
    mutate({
      values: {
        ...values,
        recaptcha: reCaptchaValue,
      },
      recaptcha: oldgoogleRecaptcha,
    })
  }

  const handleExpired = (setFieldValue) => {
    setOldGoogleRecaptcha('')
    setFieldValue('recaptcha', '')
    if (typeof document !== 'undefined' && (window as any).grecaptcha) {
      ;(window as any).grecaptcha.reset()
    }
  }

  return (
    <>
      <div
        className='d-flex flex-column flex-root w-100 justify-content-center align-items-center'
        id='kt_app_root'
      >
        <div
          className='d-flex flex-column flex-lg-row justify-content-between h-100 w-100 position-relative'
          id='loginBg'
        >
          <div
            className='d-flex flex-column w-100 h-100 p-1 sm:p-5 md:p-20 justify-content-center align-items-center'
            id='login-right'
          >
            <div
              className='d-flex align-items-center justify-content-center flex-column gap-5 md:gap-20 w-100 w-md-75'
            >
              <div className='w-100 d-flex justify-content-between align-items-center row'>
                <div className='col-12 col-lg-6 d-flex d-lg-block justify-content-between pb-5'>
                  <a
                    href={process.env.REACT_APP_DEJAVOOEXTRA}
                    className='d-block d-lg-none pt-8'
                  >
                    <img alt='Logo' src={Logo} className='h-25px' />
                    <h1 className='fs-1 fw-normal text-white' data-kt-translate='sign-in-title'>
                      {intl.formatMessage({id: 'APP_NAME'})}
                    </h1>
                  </a>

                  <div className='d-flex flex-column gap-4 d-none d-lg-block'>
                    <div className=''>
                      <a href={process.env.REACT_APP_DEJAVOOEXTRA}>
                        <img alt='Extra360 - Partner Portal' className='h-50px' src={Logo} />
                      </a>
                    </div>
                    <h1 className='fs-1 fw-normal text-white' data-kt-translate='sign-in-title'>
                      {intl.formatMessage({id: 'APP_NAME'})}
                    </h1>
                  </div>

                  <div className='my-10 w-75 d-none d-lg-block'>
                    <h1 className='text-white fs-3x fw-normal'>
                      Unlock New Growth and Elevate Your Business Success with Vasco
                    </h1>
                  </div>

                  <div className='d-flex'>
                    <a
                      className='d-flex align-items-center justify-content-between text-white'
                      href='/become-a-merchant/merchant-form'
                    >
                      <span className='fs-4 fw-bold'>
                        {intl.formatMessage({id: 'AUTH.LOGIN.BECOME_MERCHANT'})}
                      </span>

                      <i className='bi bi-arrow-right fs-2 text-white ms-3'></i>
                    </a>
                  </div>
                </div>

                <div
                  className='card ps-5 d-flex flex-column justify-content-center col-12 col-lg-6'
                  style={{
                    minHeight: '600px'
                  }}
                >
                  <Formik
                    initialValues={{
                      email: '',
                      password: '',
                      recaptcha: '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                  >
                    {({errors, touched, setFieldValue}) => (
                      <Form className='form'>
                        <div className='card-body'>
                          <div className='text-start mb-10 text-black'>
                            <h1 className='mb-3 fs-3x text-black' data-kt-translate='sign-in-title'>
                              {intl.formatMessage({id: 'AUTH.LOGIN.TITLE'})}
                            </h1>

                            <div className='fs-4 text-black' data-kt-translate='general-desc'>
                              {intl.formatMessage({id: 'AUTH.LOGIN.DESC'})}
                            </div>
                          </div>

                          <div className='fv-row mb-8 form-floating w-100'>
                            <Field
                              name='email'
                              className='form-control bg-transparent text-black'
                              type='email'
                              id='floatingInput'
                              placeholder='name@example.com'
                              maxLength={101}
                            />
                            <label>{intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}</label>
                            {errors.email && touched.email ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.email}</div>
                              </div>
                            ) : null}
                          </div>

                          <div className='fv-row mb-7 form-floating w-100'>
                            <div
                              className='position-absolute top-50 end-0 translate-middle-y fs-10 pe-6'
                              style={{cursor: 'pointer'}}
                              onClick={() => setPasswordShown(!passwordShown)}
                            >
                              <i
                                className={`bi ${passwordShown ? 'bi-eye-slash' : 'bi-eye'}`}
                                style={{fontSize: '1.4rem'}}
                              ></i>
                            </div>
                            <Field
                              id='password'
                              name='password'
                              type={passwordShown ? 'text' : 'password'}
                              className='form-control bg-transparent text-black'
                              placeholder=''
                            />
                            <label>Password</label>
                            {errors.password && touched.password ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.password}</div>
                              </div>
                            ) : null}
                          </div>

                          <div className='fv-row mb-7 form-floating w-75 w-md-100'>
                            <GoogleReCaptchaCheckbox
                              action='LOGIN'
                              callback={(token) => {
                                setFieldValue('recaptcha', token)

                                setTimeout(() => {
                                  handleExpired(setFieldValue)
                                }, 60000)
                              }}
                            />
                            {errors.recaptcha && touched.recaptcha ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.recaptcha}</div>
                              </div>
                            ) : null}
                          </div>

                          <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mt-15'>
                            <div className='w-100'>
                              <div className='d-flex flex-stack w-100 align-items-center gap-10'>
                                <button
                                  disabled={isLoading}
                                  className='btn btn-primary me-2 flex-shrink-0 px-20 py-5'
                                >
                                  <span
                                    className='indicator-label'
                                    data-kt-translate='sign-in-submit'
                                  >
                                    {isLoading ? (
                                      <span data-kt-translate='general-progress'>
                                        {intl.formatMessage({id: 'LOADING'})}
                                      </span>
                                    ) : (
                                      intl.formatMessage({id: 'AUTH.LOGIN.TITLE'})
                                    )}
                                  </span>

                                  <span className='indicator-progress'>
                                    <span data-kt-translate='general-progress'>
                                      {intl.formatMessage({id: 'LOADING'})}
                                    </span>
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                  </span>
                                </button>

                                <a
                                  href='forgot-password'
                                  data-kt-translate='sign-in-forgot-password'
                                  className='text-black w-100'
                                >
                                  {intl.formatMessage({id: 'AUTH.GENERAL.FORGOT_BUTTON'})}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SignIn
